import loadingIcon from '../assets/loading_exif_compressed.gif'

const LoadingView = () => {
    return <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: 'white' }} ><img src={loadingIcon} style={{ width: 200, height: 200 }} /></div>
}

export default LoadingView;